/**
 * Safe Suspense wrapper that prevents hydration errors
 * Ensures Suspense boundaries don't receive updates during hydration
 */

import React, { Suspense, useState, useEffect } from 'react';

interface SafeSuspenseProps {
  fallback: React.ReactNode;
  children: React.ReactNode;
  className?: string;
}

/**
 * A Suspense wrapper that prevents hydration errors by ensuring
 * the boundary is stable during the hydration process
 */
export const SafeSuspense: React.FC<SafeSuspenseProps> = ({ fallback, children, className }) => {
  const [isHydrated, setIsHydrated] = useState(false);

  useEffect(() => {
    setIsHydrated(true);
  }, []);

  // During SSR or before hydration, don't render anything to prevent flash
  if (!isHydrated) {
    return null;
  }

  // After hydration, use normal Suspense
  return <Suspense fallback={fallback}>{children}</Suspense>;
};

export default SafeSuspense;
